import { useState } from "react";
import { Link } from "react-router-dom";
import { ShieldCheck, X } from "lucide-react";

export const CookieNotice = () => {
  const [visible, setVisible] = useState(() => {
    try { return localStorage.getItem("fp-cookie-notice") !== "seen"; } catch { return true; }
  });
  if (!visible) return null;
  return <aside data-testid="cookie-notice" aria-label="Informativa cookie" className="fixed z-50 bottom-3 left-3 right-3 sm:right-auto sm:max-w-md bg-white border border-gray-200 shadow-lg rounded-lg p-3 flex items-center gap-3 text-xs text-gray-700">
    <ShieldCheck className="h-5 w-5 shrink-0 text-emerald-700" />
    <p data-testid="cookie-notice-text">Solo cookie tecnici, nessuna profilazione. <Link data-testid="cookie-policy-link" to="/cookie-policy" className="underline text-emerald-700">Cookie Policy</Link></p>
    <button data-testid="cookie-notice-dismiss" aria-label="Chiudi avviso cookie" className="p-2 shrink-0 rounded hover:bg-gray-100 transition-colors" onClick={() => { try { localStorage.setItem("fp-cookie-notice", "seen"); } catch {} setVisible(false); }}><X className="h-4 w-4" /></button>
  </aside>;
};